import { useState } from 'react'
import GridEditor from 'aldoo-ra/GridEditor'
import PubSub from 'pubsub-js'
import DigitalClock from '../Widgets/DigitalClock'
import ChartWidget from '../Widgets/ChartWidget'
import WeatherWidget from '../Widgets/WeatherWidget'

export default function GridTestPage() {
  const [slots, setSlots] = useState([
    { id: 'A', x: 0, y: 0, w: 3, h: 2, color: '#3b82f6', label: 'A', data: {} },
    { id: 'B', x: 3, y: 0, w: 3, h: 2, color: '#8b5cf6', label: 'B', data: {} },
    { id: 'C', x: 6, y: 0, w: 3, h: 2, color: '#ec4899', label: 'C', data: {} },
    { id: 'clock', x: 0, y: 2, w: 4, h: 3, view: DigitalClock, data: { type: 'clock' } },
    { id: 'chart', x: 4, y: 2, w: 4, h: 3, view: ChartWidget, data: { type: 'chart' } },
    { id: 'weather', x: 8, y: 2, w: 4, h: 3, view: WeatherWidget, data: { type: 'weather' } },
  ])

  const handleSlotsChange = (newSlots) => {
    setSlots(newSlots)
  }

  const handleAddSlot = () => {
    PubSub.publish('grid.test-grid.slot.create', {
      w: 2,
      h: 2,
      color: '#10b981',
      label: String.fromCharCode(65 + slots.length),
    })
  }

  const handleClear = () => {
    PubSub.publish('grid.test-grid.clear', {})
  }

  return (
    <div className="p-8">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-3xl font-bold">Grid Editor Test</h1>

        <div className="space-x-2">
          <button
            onClick={handleAddSlot}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Add Slot
          </button>
          <button
            onClick={handleClear}
            className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
          >
            Clear All
          </button>
        </div>
      </div>

      <GridEditor
        id="test-grid"
        initialSlots={slots}
        onChange={handleSlotsChange}
      />
    </div>
  )
}
